import BossModel from "@/models/BossModel";
import Proposal from '@/models/Proposal/Proposal'
import {mutateDateTimeWithoutSeconds} from "@/utils/mutators";

export default class ProposalNonClosingDay extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/non-closing-day';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalNonClosingDays';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            start_date: this.attr(null),
            end_date: this.attr(null),
            start_location: this.attr(null),
            end_location: this.attr(null),
            name: this.attr(null),
            message: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            // user: User,
        }
    }

    static mutators () {
        return {
            start_date: mutateDateTimeWithoutSeconds,
            end_date: mutateDateTimeWithoutSeconds,
        }
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }
}
